import { size } from 'lodash'

const showCommaAtIndex = (array, index) => index < size(array) - 1 && ', '

export default showCommaAtIndex
